import { ConversationStateModel } from "../schema/conversation-state.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class ConversationStateContainer extends MongoBaseContainer{
    conversation_state: ConversationStateModel
}